var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcn6(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e23038;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.56,18.89h3.22v3.22H28.56Zm9.66,3.22h3.22V18.89H38.22Zm24.17-3.22v9.67H59.17V39.83H51.11v6.45h5l-2,16.11H43.06V49.5H28.56V62.39H17.47l-2-16.11h3.44V39.83H10.83V28.56H7.61V18.89h3.22v6.44h3.22V18.89h3.23v9.67H14.05v8.05h4.84V31.78h8.05V28.56H20.5V23.72a14.49,14.49,0,0,1,25.78-9.1v-7h6.44v3.22H49.5V28.56H43.06v3.22h8v4.83H56v-8H52.72V18.89H56v6.44h3.22V18.89ZM46.28,25.33V23.72a11.28,11.28,0,0,0-22.56,0v1.61ZM30.17,28.56v3.22h9.66V28.56ZM25.33,56H19.91l.4,3.22h5Zm0-6.45H19.1l.4,3.22h5.83Zm22.56-3.22V35H22.11V46.28ZM51.7,56H46.28v3.22h5ZM46.28,49.5v3.22h5.83l.4-3.22ZM26.94,41.44H44.67V38.22H26.94Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 70,
    height: 70
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn6);
export default __webpack_public_path__ + "static/media/icn_6.d47b2cc1ca15b9812328ba25b89d1b01.svg";
export { ForwardRef as ReactComponent };